import { ethers, Contract, JsonRpcProvider } from "ethers";
import abi from "./nft.json";

export async function ReadContract() {
 const contractAddress = "0x62951Bc57BCEF1ECDD513522023e3F8A770ED5A4";

 //const contractAddress = "0x40c7696E2B89f551e288322E52b22c2Fa6B319E8";
 //const provider = ethers.getDefaultProvider('https://bsc-dataseed.binance.org/');

 const provider = new JsonRpcProvider("https://bsc-dataseed.binance.org/");

 //const provider = new JsonRpcProvider(
 // "https://data-seed-prebsc-1-s1.binance.org:8545"
 //);

 const contract = new Contract(contractAddress, abi, provider);
 // console.log("CONTRACTA", contract);
 return contract;
}
